import {defineStore} from 'pinia';
import {useDisplayMobile} from '@malt/utils';
import {useActiveRoute, useNavigationTabs, useMobileNavBar} from './composables';
import {useExpandedTabsStore} from './stores';

export const useAsideMenuStore = defineStore('navbar-aside-menu', () => {
    // - Display modes and mobile mode
    const {isDisplayMobile} = useDisplayMobile();
    const {isMobileNavBarOpened, setMobileNavBarOpened, toggleMobileNavBarOpened} = useMobileNavBar();
    // - Tab list
    const {logoNavigationRoute, allNavigationRoutes, filteredNavigationRoutes} = useNavigationTabs();
    // - Active tab
    const {currentActiveRoute, pathname} = useActiveRoute();

    const expandedTabsStore = useExpandedTabsStore();

    if (currentActiveRoute.value) {
        expandedTabsStore.expandTab(currentActiveRoute.value);
    }

    return {
        currentActiveRoute,
        logoNavigationRoute,
        allNavigationRoutes,
        isDisplayMobile,
        isMobileNavBarOpened,
        filteredNavigationRoutes,
        setMobileNavBarOpened,
        toggleMobileNavBarOpened,
        pathname,
    };
});
